import React, {useState} from 'react';
import {Button, Badge, Dropdown} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import {FaBars, FaCalendarAlt, FaHome, FaSignOutAlt, FaSignInAlt} from 'react-icons/fa';
import {MdNotifications, MdOutlineTipsAndUpdates} from 'react-icons/md';
import {PiMagicWandDuotone} from 'react-icons/pi'; // For notifications icon
import {PiCalendarDuotone} from 'react-icons/pi';
import {IoLogOutOutline, IoNotificationsOutline} from 'react-icons/io5';
import {RiChatHeartLine} from "react-icons/ri";
import Logo from "./shiftLogo.png";

const AppHeader = ({isLoggedIn, showLoginModal, setShowLoginModal, handleLogout, handleMenuSelect}) => {
    const [showDropdown, setShowDropdown] = useState(false);

    const handleMenuItemClick = (menuItem) => {
        handleMenuSelect(menuItem);
    };

    const handleNotificationClick = () => {
        setShowDropdown(!showDropdown);
    };

    return (
        <header className="app-header d-flex justify-content-between align-items-center p-3 bg-light sticky-top">
            <img src={Logo} alt="LazyWa" className="login-logo-header m-0"/>
            <div className="icon-menu d-flex align-items-center">
                {isLoggedIn ? (
                    <>
                        <Button variant="link" onClick={() => handleMenuItemClick('lazywa')} as={Link} to="/">
                            <PiMagicWandDuotone/>
                        </Button>
                        {/*<Button variant="link" onClick={() => handleMenuItemClick('scheduler')} as={Link}*/}
                        {/*        to="/scheduler">*/}
                        {/*    <PiCalendarDuotone/>*/}
                        {/*</Button>*/}
                        <Button variant="link" onClick={() => handleMenuItemClick('tips')} as={Link}
                                to="/tips">
                            <RiChatHeartLine />
                        </Button>
                        <Button variant="link" onClick={handleLogout} as={Link}>
                            <IoLogOutOutline/>
                        </Button>
                    </>
                ) : (
                    <Button variant="link" onClick={() => setShowLoginModal(true)}>
                        <FaSignInAlt/>
                    </Button>
                )}

            </div>
        </header>
    );
};

export default AppHeader;
